/**
 * Таблица значений — текстовая альтернатива графику.
 *
 * Не вспомогательная деталь: экранный диктор из SVG не читает ничего, кроме
 * подписи, а здесь те же числа лежат строками. Поэтому таблица остаётся в
 * разметке и на телефоне, просто свёрнутой.
 */

import { formulaText } from "../../lib/function-lab/math";
import { formatApprox } from "../../lib/function-lab/numbers";
import type { TableRow } from "../../lib/function-lab/controls";
import type { SceneCurve } from "../../lib/function-lab/model";

export function ValueTable({ rows, curves, open, onToggle }: {
  rows: TableRow[];
  /** Видимые кривые в том же порядке, в каком `valueTable` сложил ячейки. */
  curves: SceneCurve[];
  open: boolean;
  onToggle: () => void;
}) {
  return <div className="fn-lab__table">
    <button className="btn btn--quiet fn-lab__table-toggle" aria-expanded={open} onClick={onToggle}>
      Таблица значений
    </button>
    {open ? (
      <div className="fn-lab__table-scroll">
        <table>
          <caption className="fn-lab__sr">Значения функций при выбранных x</caption>
          <thead>
            <tr>
              <th scope="col">x</th>
              {curves.map((entry) => (
                <th key={entry.id} scope="col" className={`fn-lab__curve--${entry.slot}`}>
                  <span className="fn-lab__swatch" aria-hidden="true" />{formulaText(entry.curve)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.x}>
                <th scope="row">
                  {formatApprox(row.x, 2).replace(/^-/, "−")}
                  {row.label ? <span className="fn-lab__table-label">{row.label}</span> : null}
                </th>
                {row.cells.map((cell) => <td key={cell.id}>{cell.text}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : null}
  </div>;
}
